/* istanbul ignore file */
const { httpClient } = require("../gocase.api.js");

const gocatalogProducts = ({ identifier, countDevices }) =>
  httpClient
    .get(
      `/go_catalog/products/${identifier}?count_devices=${countDevices}&token=4083f9bf5ce8da0c1577b145f60f133e5b78e1c71ee6bfd8`
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

const gocatalogProductsCoverage = () =>
  httpClient
    .get(
      `/go_catalog/get_products_coverage/?token=4083f9bf5ce8da0c1577b145f60f133e5b78e1c71ee6bfd8`,
      {
        params: {
          case_types: [
            "antishockwhite",
            "deluxe",
            "antishock",
            "antishockpink",
            "antishockblack",
            "standard",
            "antishockshieldblack",
            "antishockshieldpink",
            "caseimpactslimstandard",
            "casebodytransparent",
            "antishockstandardwhite",
            "antishockstandardcitrus",
          ],
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));

export { gocatalogProducts, gocatalogProductsCoverage };
